import React from "react";
import { observer } from "mobx-react-lite";
import styled from "styled-components";
import { Message } from "../../../../../models";

const Wrap = styled.div`
  background: rgba(28, 156, 234, 0.08);
  color: #1c9cea;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 13px;
  max-width: 80vw;
`;

const OrderServerMessage: React.FC<{ message: Message }> = ({ message }) => {
  return <Wrap>{message.content || "系统订单通知"}</Wrap>;
};

export default observer(OrderServerMessage);
